// app/redux/reducers/workDaysReducer.js

import {
    SET_WORKDAYS_LOADING,
    SET_WORKDAYS_ERROR,

    GET_WORKDAYS_CONFIG_SUCCESS,
    GET_WORKDAYS_CONFIG_FAIL,
    UPDATE_WORKDAYS_CONFIG_SUCCESS,
    UPDATE_WORKDAYS_CONFIG_FAIL,

    GET_CALENDAR_SETTINGS_SUCCESS,
    GET_CALENDAR_SETTINGS_FAIL,
    UPDATE_CALENDAR_SETTINGS_SUCCESS,
    UPDATE_CALENDAR_SETTINGS_FAIL,
} from "../actions/workDaysActions";

const initialState = {
    loading: false,
    error: null,

    // data
    workdaysConfig: null,    // { weekendStart, workDays }
    calendarSettings: null,  // { fixed:[], hijri:[], custom:[] }
};

export default function workDaysReducer(state = initialState, action) {
    switch (action.type) {
        case SET_WORKDAYS_LOADING:
            return { ...state, loading: action.payload };

        case SET_WORKDAYS_ERROR:
            return { ...state, error: action.payload };

        case GET_WORKDAYS_CONFIG_SUCCESS:
            return { ...state, workdaysConfig: action.payload, error: null };
        case GET_WORKDAYS_CONFIG_FAIL:
            return { ...state, error: action.payload };

        case UPDATE_WORKDAYS_CONFIG_SUCCESS:
            return { ...state, workdaysConfig: action.payload, error: null };
        case UPDATE_WORKDAYS_CONFIG_FAIL:
            return { ...state, error: action.payload };

        case GET_CALENDAR_SETTINGS_SUCCESS:
            return { ...state, calendarSettings: action.payload, error: null };
        case GET_CALENDAR_SETTINGS_FAIL:
            return { ...state, error: action.payload };

        case UPDATE_CALENDAR_SETTINGS_SUCCESS:
            return { ...state, calendarSettings: action.payload, error: null };
        case UPDATE_CALENDAR_SETTINGS_FAIL:
            return { ...state, error: action.payload };

        default:
            return state;
    }
}
